import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a submenu view for a record table.
 * @extends JetView
 */
export default class recordTableSubMenuView extends JetView {
    /**
     * Configures the datatable view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Type of view
            select: true, // Enable row selection
            columns: [
                // Column definitions
                {
                    id: 'package', // Column ID
                    header: _('dav'), // Column header with localization
                    fillspace: 2, // Fill space proportion
                    minWidth: 100, // Minimum width of the column
                    sort: 'text', // Sorting type
                    format: dateFormat, // Formatting function for the column
                },
                {
                    id: 'maintainer', // Column ID
                    header: _('ID Usuario'), // Column header with localization
                    width: 100, // Width of the column
                    sort: 'int', // Sorting type
                },
                {
                    id: 'architecture', // Column ID
                    header: _('Transacción ID'), // Column header with localization
                    width: 100, // Width of the column
                    sort: 'int', // Sorting type
                },
            ],
            loadahead: devConfig.getDefaultDataFetch(), // Data fetching configuration
            pager: 'pagerA', // Pager ID
            url: devConfig.geturlApi() + 'es/GetSubMenu', // API endpoint for data loading
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        // Event listener for filtering submenu data
        this.on(this.app, 'submenu:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filtering
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object type filters
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom = // Format start date
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add formatted start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo = // Format end date
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add formatted end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            console.log(string1); // Log the constructed query string
            grid.load(
                // Load data into the grid
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + string1, // Append query string to URL
            );
        });

        // Event listener for loading data by user ID
        this.on(this.app, 'user:id', (Id) => {
            grid.load(grid.data.url + '?id=' + Id); // Load data for specific user ID
        });
    }
}

// FILE DOCUMENTED
